import gsap from "gsap";
import Lenis from "lenis";
import ScrollTrigger from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);
let lenis = null;
function smoothScrolling() {
	lenis = new Lenis({
		duration: .8,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		direction: "vertical", // vertical, horizontal
		gestureDirection: "vertical", // vertical, horizontal, both
		smooth: true,
		mouseMultiplier: 0.5,
		smoothTouch: false,
		touchMultiplier: 2,
		infinite: false,
	});

	lenis.on("scroll", () => {
		ScrollTrigger.update();
	});

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});

	gsap.ticker.lagSmoothing(0);

	// Handle Select2 dropdowns
	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('select2:open', function() {
			const select2Dropdown = document.querySelector('.select2-results__options');
			if (select2Dropdown) {
				select2Dropdown.setAttribute('data-lenis-prevent', '');
			}
		});

		// Also handle any existing select2 dropdowns
		const existingSelect2Dropdowns = document.querySelectorAll('.select2-results__options');
		existingSelect2Dropdowns.forEach(dropdown => {
			dropdown.setAttribute('data-lenis-prevent', '');
		});
	}

	const borderLeft = document.querySelector('[data-name="border-left"]');
	const borderRight = document.querySelector('[data-name="border-right"]');

	if (borderLeft && borderRight && lenis) {
		let lastScrollY = 0;
		const scrollThreshold = 20; // Only update every 50px of scroll
		
		lenis.on('scroll', ({ scroll, limit }) => {
			// Check if we've scrolled past the threshold
			if (Math.abs(scroll - lastScrollY) >= scrollThreshold) {
				// Calculate scroll progress percentage (20 to 80)
				const scrollProgress = 20 + ((scroll / limit) * 60);
				
				// Update CSS variables using GSAP
				gsap.set(document.documentElement, { 
					'--borderleft': `${scrollProgress}%`,
					'--borderright': `${100 - scrollProgress}%`
				});
				
				// Update last scroll position
				lastScrollY = scroll;
			}
		});
	}

}



/**
 * Open PDFs in new window
 */
function linksCustomization(){
	var pdfLinks = document.querySelectorAll('a[href$=".pdf"]')

	pdfLinks.forEach(pdf => {
		pdf.setAttribute('target', '_blank');
	});
}

/**
 * Adds smooth scrolling to anchor links
 * 
 * Adds data-scroll-to attribute to anchor links without it.
 */
function scrollTo(){
	// Function to handle smooth scrolling for anchor links
	function smoothScroll(target, offset) {
		const element = document.querySelector(target);
	
		if (element) {
			window.scrollTo({
				top: element.offsetTop - offset,
				behavior: 'smooth'
			});
		}
	}

	// Detect all anchor links on the page without data-scroll-to attribute
	const scrollToLinks = document.querySelectorAll('a[href^="#"]:not([data-scroll]):not([class^="magnific-"])')
	scrollToLinks.forEach(link => {
		// Skip those with only the hashtag
		if (link.getAttribute('href').length > 1) {
			link.setAttribute('data-scroll', 'scroll-to');
		}
	});

	
	// Event listener for anchor links
	let anchorLinks = document.querySelectorAll( '[data-scroll="scroll-to"]' )

	anchorLinks.forEach(element => {
		element.addEventListener('click', function(event) {
			const target = event.target;
		
			event.preventDefault(); // Prevent default anchor link behavior
		
			let offset = 50; // Adjust this value to set the desired offset
			if ( target.getAttribute('data-scroll-space') ){
				offset = target.getAttribute('data-scroll-space')
			}
			smoothScroll(target.getAttribute('href'), offset); // Smooth scroll to the target element with an offset
		});
	});
}

/**
 * Adds a class to tablepress tables to make them responsive.
 */
function responsiveTables(){
	/* if ( document.querySelectorAll('.tablepress').length > 0 ) {
		const tables = document.querySelectorAll('.tablepress');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			toWrap.parentNode.appendChild(wrapper);
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	} */
	if ( document.querySelectorAll('.prose table').length > 0 ) {
		const tables = document.querySelectorAll('.prose table');

		var wrap = function (toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			wrapper.classList.add('responsive-table');
			
			// Insert the wrapper before the toWrap element
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			
			return wrapper.appendChild(toWrap);
		};

		[...tables].forEach((table) => {
			wrap(table);
		});
	}
}

function destroyLenis() {
	if (lenis) {
		lenis.destroy();
		// Any additional cleanup needed
	}
}

export { linksCustomization, scrollTo, responsiveTables, smoothScrolling, lenis, destroyLenis }